






















































































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { AccountPageRecord } from '@/api/model/account'
import { translate, DateTime } from '@/utils/filters'

@Component({
    components: {
        SearchForm,
        TableForm
    }
})
export default class Personal extends Vue {
    dateTime = DateTime
    total = 0

    isLoading: boolean = false
    searchForm = {
        current: 1,
        size: 10,
        state: ''
    }
    tableData = []
    data: AccountPageRecord[] = []

    created(): void {
        this.getData()
    }

    getData(pageQuery?: object): void {
        if (pageQuery) {
            Object.assign(this.searchForm, pageQuery)
        }
        this.isLoading = true
        $Api.accountService
            .accountPage(this.searchForm)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe(res => {
                this.data = res.records
                this.total = res.total
            })
    }

    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getData()
    }

    deleteRow(row: AccountPageRecord): void {
        this.$alert(translate('nav.account.item.delete'), translate('common.tip'), {
            confirmButtonText: translate('widget.alert.yes'),
            callback: action => {
                const id = row.id
                const data = { id: id }
            }
        })
    }
}
